import { FadeIn, MaskedLines, Overline } from "@/components/Motion";

export default function PageHero({ overline, lines, sub, dark = false, children, image }) {
  return (
    <section
      className={`relative overflow-hidden ${dark ? "bg-obsidian noise-dark" : "bg-white"}`}
      data-testid="page-hero"
    >
      <div className="relative z-[2] max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-36 sm:pt-44 pb-16 sm:pb-20">
        <FadeIn>
          <Overline light={dark}>{overline}</Overline>
        </FadeIn>
        <h1
          className={`mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[0.98] max-w-4xl ${
            dark ? "text-white" : "text-slate-950"
          }`}
        >
          <MaskedLines lines={lines} immediate />
        </h1>
        {sub && (
          <FadeIn delay={0.35}>
            <p className={`mt-6 max-w-2xl text-base md:text-lg leading-relaxed ${dark ? "text-slate-400" : "text-slate-600"}`}>
              {sub}
            </p>
          </FadeIn>
        )}
        {children && <FadeIn delay={0.45}><div className="mt-8">{children}</div></FadeIn>}
      </div>
      {image && (
        <FadeIn delay={0.3} className="relative z-[2] max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
          <div className="spotlight-frame rounded-2xl overflow-hidden border border-slate-900/10">
            <img src={image} alt={overline} className="w-full h-[320px] sm:h-[440px] object-cover" loading="eager" />
          </div>
        </FadeIn>
      )}
    </section>
  );
}
